export const ROWS_PER_PAGE_LABEL = "Supplier invoices per page"
export const ROWS_PER_PAGE = 50

export const INVOICE_HEAD_CELLS = [
    { id: 'supplierName', center: true, disablePadding: false, addDollar: false, rightAlign: false, label: 'Supplier Name'},
    { id: 'date', center: true, disablePadding: false, addDollar: false, rightAlign: false, label: 'Date'},
    { id: 'poNumber', center: true, disablePadding: false, addDollar: false, rightAlign: false, label: 'PO Number'},
    { id: 'invoiceNumber', center: true, disablePadding: false, addDollar: false, rightAlign: false, label: 'Invoice Number'},
    { id: 'invoiceSubTotal', center: true, disablePadding: false, addDollar: true, rightAlign: true, label: 'Sub Total'},
    { id: 'invoiceTax', center: true, disablePadding: false, addDollar: true, rightAlign: true, label: 'Tax'},
    { id: 'invoiceTotal', center: true, disablePadding: false, addDollar: true, rightAlign: true, label: 'Total'},
    { id: 'status', center: true, disablePadding: false, addDollar: false, rightAlign: false, label: 'Status'},
    // { id: 'lastUpdatedDate', center: true, disablePadding: false, addDollar: false, rightAlign: false, label: 'Last Updated Date'},
    { id: 'delete', center: true, disablePadding: false, addDollar: false, rightAlign: false, label: ''},
]

export const INVOICE_ITEM_CELLS = [
    { id: 'shortcode', center: true, disablePadding: false, addDollar: false, rightAlign: false, readOnly: false, label: 'Shortcode'},
    { id: 'supplierPartNumber', center: true, disablePadding: false, addDollar: false, rightAlign: false, readOnly: false, label: 'Part Number'},
    { id: 'quantity', center: true, disablePadding: false, addDollar: false, rightAlign: true, readOnly: false, label: "Quantity"},
    { id: 'unitPrice', center: true, disablePadding: false, addDollar: true, rightAlign: true, readOnly: false, label: 'Price'},
    { id: 'discount', center: true, disablePadding: false, addDollar: true, rightAlign: true, readOnly: false, label: 'Discount'},
    { id: 'amount', center: true, disablePadding: false, addDollar: true, rightAlign: true, readOnly: false, label: 'Amount'},
    { id: 'tax', center: true, disablePadding: false, addDollar: true, rightAlign: true, readOnly: false, label: 'Tax'}
]

export const INVOICE_ITEM_CELLS_LEFT = [
    { id: 'shortcode', center: true, disablePadding: false, addDollar: false, rightAlign: false, readOnly: false, label: 'Shortcode'},
    { id: 'supplierPartNumber', center: true, disablePadding: false, addDollar: false, rightAlign: false, readOnly: false, label: 'Part Number'},
    { id: 'quantity', center: true, disablePadding: false, addDollar: false, rightAlign: true, readOnly: false, label: "Quantity"},
    { id: 'unitPrice', center: true, disablePadding: false, addDollar: true, rightAlign: true, readOnly: false, label: 'Price'},
]

export const INVOICE_ITEM_CELLS_RIGHT = [
    { id: 'amount', center: true, disablePadding: false, addDollar: true, rightAlign: true, readOnly: false, label: 'Amount'},
]

export const NEEDS_REVIEW_STATUS = "Needs Review"
export const APPROVE_STATUS = "Approved for Payment"
export const PAID_STATUS = "Paid"
export const DUPLICATE_STATUS = "Duplicate"

export const DEFAULT_SORT_BY_HEAD_CELL = "date"

// how long the search bar waits after the last keystroke before looking a PO number up on the server
export const SMART_SEARCH_DELAY = 600
// the lookup matches part of a PO number, so anything shorter than this would drag back half the collection
export const MIN_SMART_SEARCH_LENGTH = 3
export const SMART_SEARCH_LOADING_MESSAGE = "Searching all invoices for this PO number..."

export const ATTACHMENTS_INFO = "Upload attachments by selecting files from your computer.";

export const SUPPLIER_INVOICE_SAVE_SUCCESS_MESSAGE = "Saved"
export const SUPPLIER_INVOICE_MARKED_NEED_REVIEW_MESSAGE = "Marked need review"
export const SUPPLIER_INVOICE_APPROVED_FOR_PAYMENT_MESSAGE = "Approved"
export const SUPPLIER_INVOICE_MARKED_AS_PAID_MESSAGE = "Marked as paid"
export const SUPPLIER_INVOICE_SAVED_AND_VALIDATE_MESSAGE = "Saved and validated"
export const SUPPLIER_INVOICE_INVOICE_REPROCESSED_MESSAGE = "Invoice reprocessed"
export const SUPPLIER_INVOICE_INVOICE_ADD_PAYMENT_METHOD_MESSAGE = "Payment method added"

export const SUPPLIER_INVOICE_PAGES = {
    INVOICE: "invoice",
    PREVIEW: "preview",
    EDIT: "form",
}

// tooltip names
export const SUPPLIER_INVOICES = "Supplier Invoices"

export const PREVIEW = "Preview Cheque"
export const BACK = "Back to Menu"

export const ADD_CHEQUE = "Print Cheque"
export const PRINT_CHEQUE = "Print Cheque"

export const CHEQUE = "Cheques"
export const TRANSACTION_CALENDAR_PAGE_NAME = "Invoices Due"
export const TRANSACTION_INVOICE_PAGE_NAME = "Pending Invoices"
export const CALENDAR = "Calendar"